// helpers/rutaImputas.js
import axios from "axios";

// Base tomada del .env o fallback a producción
const RAW_BASE_URL = import.meta.env?.VITE_API_URL || "https://backsanpancracio.us-3.evennode.com";
const BASE_URL = RAW_BASE_URL.replace(/\/+$/, ""); // quita / al final
const API = axios.create({ baseURL: BASE_URL });

// arma paths sin slash inicial
const p = (s) => String(s || "").replace(/^\/+/, "");

// header con token si existe
const auth = () => {
  const token = localStorage.getItem("token") || "";
  return token ? { headers: { token } } : {};
};

// ---- IMPUTAS ----

// GET: lista
export const getImputas = async () => {
  const { data } = await API.get(p("imputas"), auth());
  // típicamente: { ok, imputas, cantidad }
  return data;
};

// GET: uno por id
export const getImputaById = async (id) => {
  const { data } = await API.get(p(`imputas/${id}`), auth());
  return data;
};

// POST: crear
export const postImputa = async (payload) => {
  const { data } = await API.post(p("imputas"), payload, auth());
  return data;
};

// PUT: actualizar
export const putImputa = async (id, payload) => {
  const { data } = await API.put(p(`imputas/${id}`), payload, auth());
  return data;
};

// DELETE: baja lógica
export const deleteImputa = async (id) => {
  const { data } = await API.delete(p(`imputas/${id}`), auth());
  return data;
};
